import {
  CameraList,
  CameraListResponse,
  RdConnectInstance,
  RdConnectInstanceListResponse,
  StringResponse,
} from '@apiContract';

import { receivedDigitalApi } from './index';

type CameraListParams = {
  rdConnectInstanceId?: number;
};

type TakeControlParams = {
  rdConnectInstanceId?: number;
};

export const receiveSessionApi = receivedDigitalApi.injectEndpoints({
  endpoints: (builder) => ({
    getInstances: builder.query<RdConnectInstance[], void>({
      query: () => 'RdConnectInstance',
      providesTags: ['ConnectInstance'],
      transformResponse: (response: RdConnectInstanceListResponse): RdConnectInstance[] => response.objectData,
    }),
    getCamerasList: builder.query<CameraList, CameraListParams>({
      query: (requestData) => ({
        url: `RdConnectInstance/camera-list/${requestData.rdConnectInstanceId}`,
        params: requestData,
      }),
      transformResponse: (response: CameraListResponse): CameraList => response.objectData,
    }),
    takeControl: builder.mutation<StringResponse, TakeControlParams>({
      query: (requestData) => ({
        url: `RdConnectInstance/take/${requestData.rdConnectInstanceId}`,
        method: 'GET',
      }),
      invalidatesTags: ['ConnectInstance'],
    }),
  }),
});

export const { useGetInstancesQuery, useGetCamerasListQuery, useTakeControlMutation } = receiveSessionApi;
